export enum LiquidationTypeEnum {
  TOTAL = 1,
  DAILY = 2,
}
